import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/bff/client';
import NoSSR from 'react-no-ssr';

import './FilterTitle.scss';

const COMMA = ',';
const SPACE = ' ';

const getFilterText = filter => trans(`search.filter_header.results.${filter}`);

const generateSuffixArray = areaSlug => [
  trans('search.filter_header.results.in'),
  trans(`city.${areaSlug}`)
];

const generateTitleElems = (types = [], areaSlug) => {
  const filterCopy = [...types];
  const lastFilter = filterCopy.pop();
  let shortTitle = lastFilter
    ? getFilterText(lastFilter)
    : trans('search.filter_header.results');

  if (filterCopy.length) {
    const connector = trans('search.filter_header.results.and');
    const baseTitle = filterCopy
      .map(filter => trans(`search.filter_header.results.${filter}`))
      .join(`${COMMA}${SPACE}`);

    shortTitle = [baseTitle, connector, getFilterText(lastFilter)].join(SPACE);
  }

  return {
    shortStr: shortTitle,
    longStr: [shortTitle, ...generateSuffixArray(areaSlug)].join(SPACE)
  };
};

const FilterTitle = ({ types, areaSlug }) => {
  const title = generateTitleElems(types, areaSlug);
  return (
    <div className="filter-title">
      <NoSSR>
        <span className="filter-title__short">{title.shortStr}</span>
      </NoSSR>
      <span className="filter-title__long">{title.longStr}</span>
    </div>
  );
};

FilterTitle.propTypes = {
  types: PropTypes.arrayOf(PropTypes.string).isRequired,
  areaSlug: PropTypes.string.isRequired
};

export default FilterTitle;
